import { render, staticRenderFns } from "./admin-main-header.vue?vue&type=template&id=05e2c0ca&"
import script from "./admin-main-header.vue?vue&type=script&lang=js&"
export * from "./admin-main-header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports